import { render } from "./packageList.vue?vue&type=template&id=a8061a2a&scoped=true"
import script from "./packageList.vue?vue&type=script&lang=js"
export * from "./packageList.vue?vue&type=script&lang=js"

import "./packageList.vue?vue&type=style&index=0&id=a8061a2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8061a2a"

export default script